import React from 'react';
import styled from 'styled-components';

const GridLine = styled.line`
  stroke: #ddd;
  stroke-width: 1;
  shape-rendering: crispEdges;
`;

const Grid = ({ xTicks, yTicks, xScale, yScale, width, height }) => {
  return (
    <g>
      {xTicks.map((tick) => (
        <GridLine
          key={`GridX_${tick}`}
          x1={xScale(tick)}
          x2={xScale(tick)}
          y1={0}
          y2={tick === 100 ? height + 24 : height}
        />
      ))}
      {yTicks.map((tick) => (
        <GridLine
          key={`GridY_${tick}`}
          x1={0}
          x2={width}
          y1={yScale(tick)}
          y2={yScale(tick)}
        />
      ))}
    </g>
  );
};

export default Grid;
